import { remove as removeDiacritics } from 'diacritics';

import { formatValidationResponse } from '../aux/utils';
import type { ValidationResult } from '../aux/types';

const hasOneUppercaseRegex = /([A-Z]+)/;
const hasOneLowercaseRegex = /([a-z]+)/;

const uppercaseMessage = 'Should have at least one uppercase character';
const lowercaseMessage = 'Should have at least one lowercase character';

export const validateOneUppercase = (password: string): ValidationResult => {
  const isRuleValid = hasOneUppercaseRegex.test(removeDiacritics(password));
  return formatValidationResponse(isRuleValid, uppercaseMessage);
};

export const validateOneLowercase = (password: string): ValidationResult => {
  const isRuleValid = hasOneLowercaseRegex.test(removeDiacritics(password));
  return formatValidationResponse(isRuleValid, lowercaseMessage);
};
